import WebApp from "@twa-dev/sdk";

/**
 * Telegram haptic feedback wrapper.
 * Fails silently if HapticFeedback is unavailable.
 */
const haptic = {
  /** Light tap — use on button presses */
  tap: () => {
    try { WebApp.HapticFeedback.impactOccurred("light"); } catch {}
  },
  /** Medium tap — use on toggles, tab switches */
  medium: () => {
    try { WebApp.HapticFeedback.impactOccurred("medium"); } catch {}
  },
  /** Success — use on claims, purchases, verifications */
  success: () => {
    try { WebApp.HapticFeedback.notificationOccurred("success"); } catch {}
  },
  /** Error — use on failed actions */
  error: () => {
    try { WebApp.HapticFeedback.notificationOccurred("error"); } catch {}
  },
  /** Warning — use on low balance, expiring items */
  warning: () => {
    try { WebApp.HapticFeedback.notificationOccurred("warning"); } catch {}
  },
};

export default haptic;
